/**
 * Service-worker bootstrap. Registers `/service-worker.js` once on app
 * load (idempotent — repeat registrations are no-ops). Adds a single
 * message listener that lets the SW deep-navigate the SPA to the
 * conversation deeplink when the user taps a push notification.
 *
 * Imported from /app/frontend/src/index.js.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  // Avoid registering when the dev server is on a different origin
  // (CRA's HMR doesn't play nicely with SWs).
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/service-worker.js');
      // Optional: log version on update
      reg.addEventListener('updatefound', () => { /* noop */ });
    } catch {
      // Non-fatal — the rest of the app works without push.
    }
  });

  // Wrapped in try/catch because iOS Safari in Private Browsing can have
  // `'serviceWorker' in navigator` return true but throw on property
  // access — we don't want that to crash the whole bundle.
  try {
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data || {};
      if (data.type === 'navigate' && data.url) {
        try {
          // Use history.pushState + a custom event so the SPA router
          // picks it up. Falls back to a hard nav if the router doesn't
          // intercept within 200ms.
          const url = data.url;
          window.history.pushState({}, '', url);
          window.dispatchEvent(new PopStateEvent('popstate'));
        } catch {
          window.location.href = data.url;
        }
      }
    });
  } catch { /* iOS Safari private mode — ignore */ }
}
